module.exports = __webpack_public_path__ + "img/pattison_pptx_background.5a914096.jpeg";